
import services from './../../services/service'; // Service Class
import SecondHeader from './../Second-Header/index.vue'; // Second Header
import MainFooter from './../Main-Footer/index.vue'; // Main Footer
//
import PaymentsAndUpdates from './../../mixins/payments_and_updates.js'; //  PaymentsAndUpdates == Resources
let service = new services();

export default {
name: 'Pricing',
mixins: [PaymentsAndUpdates],
data () {
    return {
        user:{},
        plans:{},
        plan:{},
        amount_topay:'',
        amount_paid: '',
        premium_message: '',
        request_page: '',
        plan_type: false,
        disable_btn: false,
        selected_plan: false,
        current_wallet_balance: 0,
        loggedIn: false,
        //
        payment_message:'',
        service_payment_ref: '',
        token_key:0,
        data_plan_payment_data: {},
        show_done: false,
    }
},
components: {
    'second-header': SecondHeader,
    'main-footer': MainFooter,
},
methods: {
    //settings
    preset() {
        var credentials = {
            session_key: localStorage.getItem("cityneeds_token")
        } 
        if(credentials.session_key != null) {
            service.sessionGuard(this, credentials).then(response => {
                if(response.body.status == 200) {
                    let data = response.body.data;
                    data.forEach(function(element) {
                            //this.user.user_id = element.user_id;
                            service.getUser(this, element.user_id).then(data => {
                                if(data.body.status == 200) {
                                    this.loggedIn = true;
                                    this.user = data.body.data;
                                    this.plan_type = true;
                                 }
                            }).catch((err) => {
                                if(err) {
                                   //log me
                                }
                            })
                    }, this);
                }else {
                    this.$router.push('login');
                }
            }).catch((err) => {
                if(err) {
                    this.$router.push('login');
                }
            })
        }else {
            this.$router.push('login');
        }
            
    },
    check_free_plan(plan){
        if(plan.plan_id == 1){
            return 'none';
        }
    },
    //payments
    getPaymentPlans() {
        service.getPaymentPlans(this).then(data => {
            if(data.body.status == 200) {
                this.plans = data.body.data;
            }
        }).catch((err) => {
            if(err) {
                //toastr.error('Sorry, could not process information', 'Warning!');
            }
        })
    },

    getIncomingRequest(){
        //get route params
        if((this.$route.query.pay) && (this.$route.query.pay > 0)){
            this.pay_type = this.$route.query.pay;
        }
        if((this.$route.query.re) && (this.$route.query.re != '')){
            this.service_payment_ref = this.$route.query.re;
        }
        if((this.$route.query.no) && (this.$route.query.no != '')){
            this.token_key = this.$route.query.no;
        }
        //
        this.setPayment();
    },

    setPayment(){
        if(this.pay_type == 1){ //plans and pricing
            //get the payment details
            var payload = {
                plan_ref: this.service_payment_ref,
                plan_user_token: this.token_key,
            }
            service.setPaymentPlansRequest(this, payload).then(response => {
                if(response.body.status == 200) {
                    //set payment data
                    let data = response.body.data;
                    this.data_plan_payment_data = data;
                    this.amount_topay = data.plan_amount;
                    this.user.user_id = data.plan_user_id;
                    if(response.body.data_logged_in == 1){
                        this.loggedIn = true;
                    }
                }else{
                    this.payment_message = "Sorry, could not find payment details."
                    this.show_done = true;
                }
            }).catch((err) => { })
        }
    },

    presetPaymentPlan(plan) {
        this.selected_plan = plan;
        //open modal
        $('#paywith').modal();
    },


    setPaymentPlan(pay_with_option) {
        let payment_data = {
            pay_ref: this.data_plan_payment_data.plan_ref,
            pay_user: this.data_plan_payment_data.plan_user,
            pay_email: this.data_plan_payment_data.plan_user_email,
            pay_phone: this.data_plan_payment_data.plan_user_phone,
            pay_amount: this.data_plan_payment_data.plan_amount,
            pay_service: this.data_plan_payment_data.plan_plan, //"CNpro Plans",
            pay_service_module: 9,//CNplans---plans and registration
            pay_service_module_id: this.data_plan_payment_data.plan_plan,
            pay_user_id: this.data_plan_payment_data.plan_user_id,
        }
        if(pay_with_option == "gateway"){
            //CALL PAYMENT GATEWAY
           this.processPayment(payment_data);
        }else{
            this.processPaymentWithWallet(payment_data)
        }
    },
    
    //connect to a payment gateway
    processPayment(data) {
        let obj = this;
        this.amount_paid = data.pay_amount;
        var handler = PaystackPop.setup({
        //key: 'pk_test_5e386f2b137cecdea7db6839c293614a8a115742',
        key: 'pk_live_1e88da135e1bd1205b610cac36fc6d9a27a2fbd8',
        Name: data.pay_user,
        email: data.pay_email || "admin@cityneeds.ng",
        //email: "keneinfostream@gmail.com",
        amount:  (Math.round(data.pay_amount * 100)),//(data.plan_amount * 100), //in kobo
        ref: data.pay_ref,
            metadata: {
                custom_fields: [
                    {
                        display_name: "Customer Name",
                        variable_name: "customer_name",
                        value: data.pay_user
                    },
                    {
                        display_name: "Service",
                        variable_name: "service_type",
                        value: data.pay_service
                    }
                    
                ]
            },
            
            callback: function(response){
                //post transaction
                let txn_payload = {
                    "transaction_payment_ref": data.pay_ref,
                    "transaction_module": 9,//CNplans---plans and registration
                    "transaction_module_id": data.pay_service_module_id,
                    "transaction_type": 2, //User Plans Upgrade
                    "transaction_mode": 1, //Payment Gateway
                    "transaction_mode_transaction_ref":data.pay_ref, //use here
                    "transaction_amount_paid": data.pay_amount,
                    "payer_name": data.pay_user || "",
                    "payer_email": data.pay_email || "", 
                    "payer_phone": data.pay_phone || 0,
                    "payer_user": data.pay_user_id || 0,
                };
                obj.postCNpaymentDetails(txn_payload);
                ///.///post transaction
                obj.updatePlanPayment(response.trxref); 
                
            },
            onClose: function(){
                alert('window closed');
            }
            }); 
            handler.openIframe();
        },

    processPaymentWithWallet(data){
        this.amount_paid = data.pay_amount;
        var payload ={
            pay: this.user.user_id, // data.plan_user_id
            txn_amount: data.pay_amount,
            service: 1,//plans and registration
            service_ref: data.pay_ref
        }
        service.postWalletPayout(this, payload).then(response => {
            if(response.body.status == 201) {
                var txref = response.body.data_txn_ref;
                //post transaction
                let txn_payload = {
                    "transaction_payment_ref": data.pay_ref,
                    "transaction_module": 9,//CNplans---plans and registration
                    "transaction_module_id": data.pay_service_module_id,
                    "transaction_type": 2, //User Plans Upgrade
                    "transaction_mode": 2, //CNrewards-Wallet
                    "transaction_mode_transaction_ref":txref, //use here
                    "transaction_amount_paid": data.pay_amount,
                    "payer_name": data.pay_user || "",
                    "payer_email": data.pay_email || "", 
                    "payer_phone": data.pay_phone || 0,
                    "payer_user": data.pay_user_id || 0,
                };
                this.postCNpaymentDetails(txn_payload);
                ///.///post transaction
                this.updatePlanPayment(response.body.data)
            }
        }).catch((err) => {
            if(err) {
                toastr.error('Sorry, could not process information', 'Warning!');
            }
        })
    },

        // update payments
        updatePlanPayment(payment_ref) {
            var credentials = {
                amount_paid: this.amount_paid,
                plan_user_id: this.user.user_id,
                record_transaction:0,
            }
            let navi = this.$router;
            
            if(payment_ref != "") {
                service.updatePaymentPlan(this, payment_ref, credentials).then(data => {
                    if(data.body.status == 200) {
                        toastr.success("Payment Processed!", "Success!");
                        this.payment_message = "Payment was successful";
                        this.show_done = true;
                    }else {
                        toastr.error('Sorry, could not update payment', 'Warning!');
                    }
                }).catch((err) => {
                    if(err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
            }else {
               toastr.error('Something went wrong', 'Warning!');
            }
            
        },

    //wallet calls
    getWalletTransactions() {
        let user_id = this.token_key;
        service.getWalletTransactions(this,user_id).then(data => {
            if(data.body.status == 200) {
                this.current_wallet_balance = data.body.data_current_wallet_balance;
            }
         }).catch((err) => {
            if(err) {
                toastr.error('Sorry, could not process information', 'Warning!');
            }
         })
    },

    formatCurrency(currency){
        currency =  Intl.NumberFormat('en-US', { style: 'currency', currency: 'NGN'}).format(currency);
        return currency.replace("NGN", ""); //strip off NGN
    },

    //....wallet calls
},


created: function(){
    //clear storage
    localStorage.clear();
    //
    this.getIncomingRequest();
    this.getWalletTransactions();

    //
    if(localStorage.getItem("cityneeds_user") != null) {
        //this.preset();
    }
}

}


// WEBPACK FOOTER //
// ./src/components/PricingPayments/script.js